<div class="page-container custom-page-background position-absolute">
  <div class="forgot-password-page">

    <div class="forgot-password-form">
      <div class="forgot-password-form-container">
        <div class="header">
          <div class="hass-logo" style=" max-width: 270px; margin: 0 auto;">
            <img src="/src/assets/images/HASSLogo.png" />
          </div>

          <p>where <strong>excellent hearing</strong> begins</p>
        </div>

        <div class="sub-header" style="text-transform: uppercase;">
          <h2>Satisfaction Survey</h2>
        </div>
        <div class="form">

          <!-- Question 1 -->
          <div class="form-group">
            <label>1. {{ survey.QuestionField1 }}</label>
            <div class="row justify-space-around">
              <span *ngFor="let option of Field1Ratings.ratingOptions; let i = index"
                    class="star"
                    [class.filled]="option"
                    (click)="selectRating(Field1Ratings, i + 1)">
                ★
              </span>
            </div>
          </div>

          <!-- Example for Question 2 -->
          <div class="form-group">
            <label>2. {{ survey.QuestionField2 }}</label>
            <div class="row justify-space-around">
              <span *ngFor="let option of Field2Ratings.ratingOptions; let i = index"
                    class="star"
                    [class.filled]="option"
                    (click)="selectRating(Field2Ratings, i + 1)">
                ★
              </span>
            </div>
          </div>

          <!-- Example for Question 3 -->
          <div class="form-group">
            <label>3. {{ survey.QuestionField3 }}</label>
            <div class="row justify-space-around">
              <span *ngFor="let option of Field3Ratings.ratingOptions; let i = index"
                    class="star"
                    [class.filled]="option"
                    (click)="selectRating(Field3Ratings, i + 1)">
                ★
              </span>
            </div>
          </div>
          <div class="button-group" style="width: 100%">
            <button type="button" class="custom-btn" (click)="MemberSurveyAnswersSet()">Submit</button>
          </div>
          <div class="form-footer">
            <div>
              <p><small>Copy &copy;2024 H.A.S.S Ear Institute</small></p>
              <small><a style="margin-right: 10px">Term of Service</a> | <a style="margin-left: 10px">Privacy Policy</a></small>
            </div>

          </div>
        </div>

    </div>

  </div>
</div>
  </div>
